import {getThemeConfig} from "@buildwithflux/mui-theme";
import {createTheme} from "@mui/material/styles";

const fontFamily = '"Roboto", "Roboto Fallback", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
const themeOptions = getThemeConfig(true);
const cssBaselineStyleOverrides = themeOptions.components?.MuiCssBaseline?.styleOverrides;

// Same theme config as the main app so both render paths match production.
export const theme = createTheme({
    ...themeOptions,
    typography: {
        ...themeOptions.typography,
        fontFamily,
    },
    components: {
        ...themeOptions.components,
        MuiCssBaseline: {
            ...themeOptions.components?.MuiCssBaseline,
            styleOverrides: (muiTheme) => {
                const overrides =
                    typeof cssBaselineStyleOverrides === "function"
                        ? cssBaselineStyleOverrides(muiTheme)
                        : cssBaselineStyleOverrides;
                const styles =
                    typeof overrides === "object" && overrides !== null && !Array.isArray(overrides)
                        ? (overrides as Record<string, unknown>)
                        : {};
                const bodyStyles = styles.body;

                return {
                    ...styles,
                    body: {
                        ...(typeof bodyStyles === "object" && bodyStyles !== null && !Array.isArray(bodyStyles)
                            ? bodyStyles
                            : {}),
                        fontFamily,
                    },
                };
            },
        },
    },
});
